'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildApolloConfiguredClientFactory = exports.buildObservableQuery = exports.buildQueryObserver = undefined;

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

var _buildApolloParams = require('./buildApolloParams');

var _buildApolloParams2 = _interopRequireDefault(_buildApolloParams);

var _getApolloPromise = require('./getApolloPromise');

var _getApolloPromise2 = _interopRequireDefault(_getApolloPromise);

var _handleError = require('./handleError');

var _handleError2 = _interopRequireDefault(_handleError);

var _parseApolloResponse = require('./parseApolloResponse');

var _parseApolloResponse2 = _interopRequireDefault(_parseApolloResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildQueryObserver = exports.buildQueryObserver = function buildQueryObserver(type, resource, apolloParams, observer) {
    return {
        complete: function complete() {
            observer.complete();
        },
        error: function error() {
            observer.error();
        },
        next: function next(apolloQueryResult) {
            var parsedApolloQueryResult = (0, _parseApolloResponse2.default)(apolloQueryResult, type, resource, apolloParams);

            observer.next(parsedApolloQueryResult);
        }
    };
};

var buildObservableQuery = exports.buildObservableQuery = function buildObservableQuery(type, resource, apolloParams, observableQuery) {
    return {
        subscribe: function subscribe(observer) {
            var queryObserver = buildQueryObserver(type, resource, apolloParams, observer);
            var subscription = observableQuery.subscribe(queryObserver);

            return {
                unsubscribe: function unsubscribe() {
                    subscription.unsubscribe();
                }
            };
        }
    };
};

var buildApolloConfiguredClientFactory = exports.buildApolloConfiguredClientFactory = function buildApolloConfiguredClientFactory(buildApolloParamsImpl, getApolloPromiseImpl, parseApolloResponseImpl, handleErrorImpl) {
    return function (client, queries) {
        return {
            handleRequest: function handleRequest(type, resource, params) {
                var apolloParams = buildApolloParamsImpl(queries, type, resource, params);

                return getApolloPromiseImpl(client)(type, apolloParams).then(function (response) {
                    return parseApolloResponseImpl(response, type, resource, apolloParams);
                }).catch(handleErrorImpl);
            },
            watchRequest: function watchRequest(type, resource, params, apolloWatchParameters) {
                var apolloParams = buildApolloParamsImpl(queries, type, resource, params);
                var observableQuery = client.watchQuery((0, _lodash2.default)({}, apolloParams, apolloWatchParameters));

                return buildObservableQuery(type, resource, apolloParams, observableQuery);
            }
        };
    };
};

exports.default = buildApolloConfiguredClientFactory(_buildApolloParams2.default, _getApolloPromise2.default, _parseApolloResponse2.default, _handleError2.default);


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/buildApolloConfiguredClient.js
// module id = 926
// module chunks = 0